export interface Manga {
  slug: string;
  title: string;
  author: string;
  category: string;
  coverImage: string;
  description: string;
  rating: number;
  views: number;
  chapters: number;
  status: '连载中' | '已完结';
  updateDate: string;
  tags: string[];
  chapterList: { id: number; title: string; date: string }[];
}

export const mangaList: Manga[] = [
  {
    slug: 'queen-of-tears',
    title: '眼泪女王',
    author: '李智慧',
    category: 'love',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20romance%20cover%20art%20style%2C%20beautiful%20couple%20embracing%20with%20tears%2C%20soft%20pastel%20pink%20background%2C%20delicate%20line%20art%2C%20dramatic%20emotional%20atmosphere%2C%20clean%20composition%2C%20warm%20lighting%2C%20professional%20digital%20illustration%20with%20Korean%20text%20elements&width=400&height=560&seq=manga-cover-01&orientation=portrait',
    description: '结婚三年，白贤宇以为自己和妻子洪海仁形同陌路。然而当妻子被诊断出绝症后，他才发现原来自己从未真正了解过她。一场关于爱情、救赎与成长的故事就此展开。',
    rating: 9.5,
    views: 1250000,
    chapters: 48,
    status: '连载中',
    updateDate: '2026-08-03',
    tags: ['恋爱', '都市', '治愈', '韩漫'],
    chapterList: Array.from({ length: 48 }, (_, i) => ({
      id: 48 - i,
      title: `第${48 - i}话 ${['初遇', '告白', '危机', '转机', '真相', '抉择', '和解', '新生'][i % 8]}`,
      date: `2026-0${Math.ceil((48 - i) / 15)}-${String((48 - i) % 28 + 1).padStart(2, '0')}`,
    })),
  },
  {
    slug: 'sword-master',
    title: '剑尊归来',
    author: '金泰亨',
    category: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20warrior%20with%20sword%20cover%20art%2C%20powerful%20martial%20artist%20in%20dynamic%20pose%2C%20dramatic%20red%20and%20gold%20background%2C%20epic%20fantasy%20atmosphere%2C%20clean%20bold%20line%20art%2C%20professional%20digital%20illustration%20webtoon%20style&width=400&height=560&seq=manga-cover-02&orientation=portrait',
    description: '一代剑尊慕容天，在击败天下第一高手后意外陨落，却重生回到了二十年前的少年时代。带着前世的记忆和剑术，他要改写命运，再次踏上巅峰之路。',
    rating: 9.7,
    views: 2380000,
    chapters: 156,
    status: '连载中',
    updateDate: '2026-08-04',
    tags: ['动作', '武侠', '重生', '热血'],
    chapterList: Array.from({ length: 156 }, (_, i) => ({
      id: 156 - i,
      title: `第${156 - i}话 ${['重生', '修炼', '切磋', '突破', '决战', '复仇', '觉醒', '归来'][i % 8]}`,
      date: `2026-0${Math.ceil((156 - i) / 40)}-${String((156 - i) % 28 + 1).padStart(2, '0')}`,
    })),
  },
  {
    slug: 'other-world-chef',
    title: '异世界料理师',
    author: '朴敏英',
    category: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cooking%20cover%20art%2C%20chef%20in%20magical%20kitchen%20with%20floating%20ingredients%2C%20warm%20golden%20amber%20background%2C%20whimsical%20atmosphere%2C%20detailed%20food%20illustration%2C%20clean%20line%20art%2C%20professional%20webtoon%20digital%20art&width=400&height=560&seq=manga-cover-03&orientation=portrait',
    description: '天才厨师韩宇意外穿越到剑与魔法的异世界。在这个美食文化匮乏的世界，他决定用现代料理征服所有人的胃，从一介小厨师成长为异世界的美食之王。',
    rating: 9.3,
    views: 890000,
    chapters: 72,
    status: '连载中',
    updateDate: '2026-08-02',
    tags: ['奇幻', '美食', '异世界', '冒险'],
    chapterList: Array.from({ length: 72 }, (_, i) => ({
      id: 72 - i,
      title: `第${72 - i}话 ${['降临', '初试', '惊艳', '挑战', '成长', '对决', '盛宴', '传说'][i % 8]}`,
      date: `2026-0${Math.ceil((72 - i) / 20)}-${String((72 - i) % 28 + 1).padStart(2, '0')}`,
    })),
  },
  {
    slug: 'detective-in-the-dark',
    title: '暗夜侦探',
    author: '郑秀晶',
    category: 'thriller',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20thriller%20cover%20art%2C%20detective%20in%20trench%20coat%20in%20dark%20alley%2C%20moody%20noir%20atmosphere%2C%20dramatic%20shadows%20and%20low%20lighting%2C%20clean%20bold%20line%20art%2C%20suspenseful%20tone%2C%20professional%20digital%20webtoon%20illustration&width=400&height=560&seq=manga-cover-04&orientation=portrait',
    description: '连环杀人案震惊全城，天才犯罪心理学家林寒加入调查。每一个案发现场都留下了诡异的符号，似乎指向一场更大的阴谋。当真相逐渐浮出水面，林寒发现自己也成为棋局中的一枚棋子。',
    rating: 9.4,
    views: 670000,
    chapters: 36,
    status: '已完结',
    updateDate: '2026-06-15',
    tags: ['悬疑', '推理', '犯罪', '心理'],
    chapterList: Array.from({ length: 36 }, (_, i) => ({
      id: 36 - i,
      title: `第${36 - i}话 ${['开端', '线索', '迷雾', '追踪', '反转', '真相', '对决', '终章'][i % 8]}`,
      date: `2026-0${Math.ceil((36 - i) / 10)}-${String((36 - i) % 28 + 1).padStart(2, '0')}`,
    })),
  },
  {
    slug: 'office-laugh',
    title: '职场爆笑日记',
    author: '赵恩静',
    category: 'comedy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20office%20life%20cover%20art%2C%20funny%20office%20workers%20with%20exaggerated%20expressions%2C%20bright%20yellow%20and%20orange%20background%2C%20lighthearted%20humorous%20atmosphere%2C%20clean%20cartoonish%20line%20art%2C%20playful%20digital%20webtoon%20illustration&width=400&height=560&seq=manga-cover-05&orientation=portrait',
    description: '职场新人苏小糖入职第一天就遇到了奇葩老板和搞笑同事。每天都在各种乌龙事件中度过，看小糖如何用乐观的心态应对职场的酸甜苦辣。',
    rating: 8.9,
    views: 450000,
    chapters: 24,
    status: '连载中',
    updateDate: '2026-08-01',
    tags: ['搞笑', '职场', '日常', '轻松'],
    chapterList: Array.from({ length: 24 }, (_, i) => ({
      id: 24 - i,
      title: `第${24 - i}话 ${['入职', '乌龙', '团建', '加班', '年终', '升职', '离职', '新生'][i % 8]}`,
      date: `2026-0${Math.ceil((24 - i) / 8)}-${String((24 - i) % 28 + 1).padStart(2, '0')}`,
    })),
  },
  {
    slug: 'ghost-dormitory',
    title: '鬼怪宿舍',
    author: '崔雪莉',
    category: 'horror',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20supernatural%20cover%20art%2C%20haunted%20dormitory%20with%20ghostly%20figure%2C%20dark%20purple%20and%20black%20eerie%20background%2C%20spooky%20atmosphere%20with%20mist%2C%20clean%20detailed%20line%20art%2C%20professional%20horror%20digital%20webtoon%20illustration&width=400&height=560&seq=manga-cover-06&orientation=portrait',
    description: '转学生陈灵搬进了一间传闻中闹鬼的宿舍。深夜走廊的脚步声、镜子里若隐若现的人影、午夜准时响起的电话铃……每一个夜晚都是一场生与死的考验。',
    rating: 8.7,
    views: 320000,
    chapters: 18,
    status: '已完结',
    updateDate: '2026-05-20',
    tags: ['恐怖', '灵异', '校园', '惊悚'],
    chapterList: Array.from({ length: 18 }, (_, i) => ({
      id: 18 - i,
      title: `第${18 - i}话 ${['入住', '异响', '影子', '走廊', '镜子', '铃声', '真相', '终局'][i % 8]}`,
      date: `2026-0${Math.ceil((18 - i) / 6)}-${String((18 - i) % 28 + 1).padStart(2, '0')}`,
    })),
  },
  {
    slug: 'campus-spring',
    title: '校园之春',
    author: '孙艺珍',
    category: 'school',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20romance%20cover%20art%2C%20students%20under%20cherry%20blossom%20trees%20on%20campus%2C%20soft%20pink%20and%20green%20spring%20background%2C%20warm%20youthful%20atmosphere%2C%20clean%20delicate%20line%20art%2C%20professional%20webtoon%20digital%20illustration&width=400&height=560&seq=manga-cover-07&orientation=portrait',
    description: '春天来了，樱花盛开的校园里，学霸班长和转学来的美术生相遇了。两个性格迥异的年轻人，在青春的校园里谱写了一段纯真美好的爱情故事。',
    rating: 9.1,
    views: 780000,
    chapters: 54,
    status: '连载中',
    updateDate: '2026-08-03',
    tags: ['校园', '恋爱', '青春', '治愈'],
    chapterList: Array.from({ length: 54 }, (_, i) => ({
      id: 54 - i,
      title: `第${54 - i}话 ${['邂逅', '相识', '悸动', '误会', '告白', '甜蜜', '考验', '永恒'][i % 8]}`,
      date: `2026-0${Math.ceil((54 - i) / 15)}-${String((54 - i) % 28 + 1).padStart(2, '0')}`,
    })),
  },
  {
    slug: 'kingdom-of-joseon',
    title: '朝鲜王朝秘史',
    author: '金秀贤',
    category: 'history',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20drama%20cover%20art%2C%20Joseon%20dynasty%20royal%20palace%20with%20traditional%20hanbok%20figures%2C%20elegant%20brown%20and%20gold%20classical%20background%2C%20dignified%20atmosphere%2C%20clean%20refined%20line%20art%2C%20professional%20historical%20webtoon%20digital%20illustration&width=400&height=560&seq=manga-cover-08&orientation=portrait',
    description: '朝鲜时代，一位出身卑微的书生通过科举入仕，却卷入了一场宫廷权力斗争。在风云变幻的历史洪流中，他将如何坚守本心，书写自己的传奇？',
    rating: 9.0,
    views: 540000,
    chapters: 42,
    status: '已完结',
    updateDate: '2026-04-10',
    tags: ['历史', '宫廷', '权谋', '正剧'],
    chapterList: Array.from({ length: 42 }, (_, i) => ({
      id: 42 - i,
      title: `第${42 - i}话 ${['科举', '入朝', '暗流', '危机', '政变', '对决', '胜利', '归隐'][i % 8]}`,
      date: `2026-0${Math.ceil((42 - i) / 12)}-${String((42 - i) % 28 + 1).padStart(2, '0')}`,
    })),
  },
  {
    slug: 'the-last-superhero',
    title: '最后的超级英雄',
    author: '李东旭',
    category: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20superhero%20action%20cover%20art%2C%20hero%20flying%20over%20city%20skyline%20with%20energy%20aura%2C%20dynamic%20red%20and%20orange%20background%2C%20epic%20cinematic%20atmosphere%2C%20clean%20bold%20line%20art%2C%20professional%20digital%20webtoon%20illustration&width=400&height=560&seq=manga-cover-09&orientation=portrait',
    description: '在超级英雄几乎绝迹的时代，最后一个拥有超能力的人选择隐姓埋名。直到一场前所未有的危机降临，他不得不再次穿上战衣，守护这个不再相信英雄的世界。',
    rating: 9.2,
    views: 1050000,
    chapters: 60,
    status: '连载中',
    updateDate: '2026-08-04',
    tags: ['动作', '超级英雄', '科幻', '热血'],
    chapterList: Array.from({ length: 60 }, (_, i) => ({
      id: 60 - i,
      title: `第${60 - i}话 ${['隐居', '危机', '归来', '试炼', '集结', '决战', '牺牲', '新生'][i % 8]}`,
      date: `2026-0${Math.ceil((60 - i) / 16)}-${String((60 - i) % 28 + 1).padStart(2, '0')}`,
    })),
  },
  {
    slug: 'love-contract',
    title: '恋爱契约',
    author: '朴宝英',
    category: 'love',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20contract%20marriage%20cover%20art%2C%20elegant%20couple%20in%20formal%20attire%20with%20contract%20paper%2C%20soft%20peach%20and%20rose%20background%2C%20romantic%20atmosphere%2C%20clean%20delicate%20line%20art%2C%20professional%20webtoon%20digital%20illustration&width=400&height=560&seq=manga-cover-10&orientation=portrait',
    description: '为了保住家族企业，千金小姐被迫与商业对手签订了一份恋爱契约。从最初的针锋相对到逐渐了解彼此，真假难辨的感情让人欲罢不能。',
    rating: 9.0,
    views: 920000,
    chapters: 38,
    status: '连载中',
    updateDate: '2026-08-02',
    tags: ['恋爱', '契约', '都市', '甜宠'],
    chapterList: Array.from({ length: 38 }, (_, i) => ({
      id: 38 - i,
      title: `第${38 - i}话 ${['契约', '初遇', '交锋', '心动', '试探', '沉沦', '真相', '真爱'][i % 8]}`,
      date: `2026-0${Math.ceil((38 - i) / 10)}-${String((38 - i) % 28 + 1).padStart(2, '0')}`,
    })),
  },
  {
    slug: 'magic-academy',
    title: '魔法学院',
    author: '郑在玹',
    category: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20magic%20academy%20fantasy%20cover%20art%2C%20students%20casting%20spells%20in%20grand%20academy%20hall%2C%20mystical%20green%20and%20gold%20background%2C%20enchanting%20atmosphere%2C%20clean%20detailed%20line%20art%2C%20professional%20webtoon%20digital%20illustration&width=400&height=560&seq=manga-cover-11&orientation=portrait',
    description: '没有魔力的少年意外被顶尖魔法学院录取，在这个强者为尊的世界，他凭借智慧和勇气一步步揭开了学院隐藏千年的秘密。',
    rating: 9.1,
    views: 810000,
    chapters: 66,
    status: '连载中',
    updateDate: '2026-08-04',
    tags: ['奇幻', '魔法', '学院', '冒险'],
    chapterList: Array.from({ length: 66 }, (_, i) => ({
      id: 66 - i,
      title: `第${66 - i}话 ${['入学', '测试', '觉醒', '试练', '危机', '揭秘', '决战', '传奇'][i % 8]}`,
      date: `2026-0${Math.ceil((66 - i) / 18)}-${String((66 - i) % 28 + 1).padStart(2, '0')}`,
    })),
  },
  {
    slug: 'revenge-of-the-shadow',
    title: '暗影复仇记',
    author: '吴世勋',
    category: 'thriller',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20revenge%20thriller%20cover%20art%2C%20mysterious%20figure%20in%20shadow%20with%20city%20night%20scene%2C%20dark%20atmospheric%20background%20with%20neon%20accents%2C%20tense%20mood%2C%20clean%20sharp%20line%20art%2C%20professional%20webtoon%20digital%20illustration&width=400&height=560&seq=manga-cover-12&orientation=portrait',
    description: '十年前被冤枉入狱的男人出狱后，发现一切都变了。他化身暗影，步步为营，誓要向那些毁掉他人生的幕后黑手复仇。',
    rating: 9.3,
    views: 730000,
    chapters: 28,
    status: '连载中',
    updateDate: '2026-08-01',
    tags: ['悬疑', '复仇', '犯罪', '剧情'],
    chapterList: Array.from({ length: 28 }, (_, i) => ({
      id: 28 - i,
      title: `第${28 - i}话 ${['出狱', '追踪', '潜入', '布局', '收网', '对决', '真相', '终局'][i % 8]}`,
      date: `2026-0${Math.ceil((28 - i) / 8)}-${String((28 - i) % 28 + 1).padStart(2, '0')}`,
    })),
  },
];